var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bracodes"}},_vm._l((_vm.numbers),function(item,index){return _c('div',{key:index},[_vm._v("\n        220,000\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }